/**
 * 1xx - client side errors
 */

export const CP_101_ERROR = 'CP-101'
export const CP_102_ERROR = 'CP-102'
export const CP_103_ERROR = 'CP-103'

/**
 * 2xx - ID errors
 */

export const CP_201_ERROR = 'CP-201'
export const CP_202_ERROR = 'CP-202'
export const CP_203_ERROR = 'CP-203'

/**
 * 3xx - CS errors
 */

export const CP_301_ERROR = 'CP-301'
export const CP_302_ERROR = 'CP-302'
export const CP_303_ERROR = 'CP-303'

/**
 * 4xx - resource upload error codes
 */
export const CP_400 = 'CP-400'
export const CP_401 = 'CP-401'
export const CP_402 = 'CP-402'
export const CP_403 = 'CP-403'
export const CP_404 = 'CP-404'

/**
 * 5** - legacy exchange url
 */
export const CP_500_ERROR = 'CP-500'
